import { render, staticRenderFns } from "./Proceso.vue?vue&type=template&id=6626ba5e&scoped=true&"
import script from "./Proceso.vue?vue&type=script&lang=js&"
export * from "./Proceso.vue?vue&type=script&lang=js&"
import style0 from "./Proceso.vue?vue&type=style&index=0&id=6626ba5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6626ba5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCard,VCardText,VStepper,VStepperContent,VStepperStep})
